/**
 * 统一订单状态字典
 * 后端返回:
 *   type:  0=普通申请中 1=正常订单 2=退保 3=理赔
 *   status: 0=待审批 1=已申请 2=已取消 3=已完成
 *   state: 0=待缴费 1=未缴费 2=已超时 3=已缴费
 *   invoice: 1=未申请 2=申请中 3=已开票
 */

const PRIMARY_TAGS = {
  '0': { text: '待审批', type: 'primary' },
  '1': { text: '已申请', type: 'primary' },
  '2': { text: '已取消', type: 'info' },
  '3': { text: '已完成', type: 'success' }
}

const STATE_TAGS = {
  '0': { text: '待缴费', type: 'primary' },
  '1': { text: '未缴费', type: 'warning' },
  '2': { text: '已超时', type: 'danger' },
  '3': { text: '已缴费', type: 'success' }
}

const TYPE_TAGS = {
  '2_open':  { text: '退保中', type: 'danger' },
  '2_done':  { text: '已退保', type: 'info' },
  '3_open':  { text: '理赔中', type: 'danger' },
  '3_done':  { text: '已理赔', type: 'info' }
}

const INVOICE_TAGS = {
  '1': { text: '未申请发票', type: 'info' },
  '2': { text: '发票申请中', type: 'warning' },
  '3': { text: '已开票', type: 'success' }
}

export function getOrderTag (item) {
  const tags = []

  if (item.type === '2' || item.type === '3') {
    const key = `${item.type}_${item.status === '3' ? 'done' : 'open'}`
    if (TYPE_TAGS[key]) tags.push(TYPE_TAGS[key])
    if (item.status === '2') {
      tags.push({
        text: item.type === '2' ? '退保被驳回' : '理赔被驳回',
        type: 'danger'
      })
    }
  } else {
    if (PRIMARY_TAGS[item.status]) tags.push(PRIMARY_TAGS[item.status])
    if (item.status === '1' && STATE_TAGS[item.state]) tags.push(STATE_TAGS[item.state])
  }

  if (item.invoice && INVOICE_TAGS[item.invoice]) tags.push(INVOICE_TAGS[item.invoice])

  return tags
}

export default { getOrderTag }
